import React, { useEffect, useState } from 'react'
import {
    InputFieldText,
    InputFieldSelect,
    FieldGroup,
    Field,
    SubmitButton,
    ButtonContainer,
    FieldContainer,
    FormCard,
    SubmitButtonMail,
} from '../../reusable'

import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { sectionValidation } from '../../../helpers'

export const ContactDetails = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [errors, setErrors] = useState<{ [key: string]: string }>({})
    const [showFieldErrors, setShowFieldErrors] = useState(false)
    const [formValid, setFormValid] = useState(false)
    const [validationResults, setValidationResults] = useState<{ [key: string]: boolean }>({})

    useEffect(() => {
        checkFormValidity()
    }, [])

    useEffect(() => {
        checkFormValidity()
    }, [stepData, errors, validationResults])

    const checkFormValidity = () => {
        const telephoneValid = stepData.telephone && stepData.telephone.trim() !== '' && validationResults.telephone
        const emailValid = stepData.email && stepData.email.trim() !== '' && validationResults.email

        const noErrors = !errors.telephone && !errors.email

        const isValid = telephoneValid && emailValid && noErrors

        console.log(
            'Form validation check:',
            isValid,
            'Telephone:',
            telephoneValid,
            'Email:',
            emailValid,
            'No Errors:',
            noErrors,
            'Errors Object:',
            errors
        )

        setFormValid(isValid)
    }

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)

        setStepData((prevData: any) => ({
            ...prevData,
            [dataToSave.field]: dataToSave.value,
        }))

        setValidationResults((prev) => ({
            ...prev,
            [dataToSave.field]: !saved.error,
        }))

        if (dataToSave.value.trim()) {
            setErrors((prev) => ({
                ...prev,
                [dataToSave.field]: '',
            }))
        }

        return saved
    }

    const handleBack = () => {
        assignGroup('person')
    }

    const animateBeforeAssign = (assignment: string) => {
        setShowFieldErrors(true)

        const allFields = ['telephone', 'email']
        let isValid = true
        let newErrors = { ...errors }

        allFields.forEach((field) => {
            if (!stepData[field] || stepData[field].trim() === '') {
                newErrors[field] = 'This field is required'
                isValid = false
            } else if (!validationResults[field]) {
                newErrors[field] = 'Invalid ' + field
                isValid = false
            } else {
                delete newErrors[field]
            }
        })

        setErrors(newErrors)

        if (!isValid) return

        console.log('next section')

        setTimeout(() => {
            assignGroup(assignment)
        }, 400)
    }

    const getCurrentStep = () => {
        return isActive == 'contact' ? (
            <FieldGroup title="Contact Information">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <h3>Contact Details</h3>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Telephone" labelPosition="left">
                        <InputFieldText
                            fieldName="telephone"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.telephone || ''}
                            fieldType={'tel'}
                            required={true}
                            showErrors={showFieldErrors}
                            enhanced={true}
                        />
                    </Field>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Email" labelPosition="left">
                        <InputFieldText
                            fieldName="email"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.email || ''}
                            fieldType={'email'}
                            required={true}
                            showErrors={showFieldErrors}
                            enhanced={true}
                        />
                    </Field>
                    <p style={{ paddingTop: '16px' }}>
                        By clicking submit, you confirm you give your permission for Sentinel Legal Ltd to contact you
                        by telephone, e-mail or post regarding your claim.
                    </p>
                    <div className="button-container" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <SubmitButtonMail
                            text="Continue"
                            btnType="primary"
                            onClick={() => animateBeforeAssign('address')}
                            disabled={!formValid}
                        />
                    </div>
                    <div style={{ marginTop: '16px', padding: '14px 16px', background: '#eef7fc', borderRadius: '10px', border: '1px solid #c8e6f5' }}>
                        <p style={{ margin: '0 0 4px', fontWeight: 700, fontSize: '14px', color: '#1a1a2e' }}>Privacy Promise:</p>
                        <p style={{ margin: 0, fontSize: '13px', color: '#555', lineHeight: '1.5' }}>Your contact information is secure and will only be used to communicate about your claim. We never share your details without your consent.</p>
                    </div>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
